import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `deleteView` request params
 * (what is used to send to server)
 */
export type DeleteViewRequestOptions = {
	id: number;
};

/**
 * `deleteView` request
 * (what gets sent to the server)
 */
export type DeleteViewRequest = [DeleteViewRequestOptions['id']];

/**
 * `deleteView` response
 * (what comes back from the server)
 */
export type DeleteViewResponse = SuccessResponse<boolean>;

/**
 * `deleteView` result
 * (what is utilized from the server response)
 */
export type DeleteViewResult = number;

export const deleteViewEndpoint = 'deleteView';

/**
 * Delete view
 * @param fetchParams Fetch params
 */
export const deleteView = async ({id}: DeleteViewRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: DeleteViewRequest = [id];

	return client
		.post<DeleteViewResponse>(deleteViewEndpoint, requestParams)
		.then(() => id);
};

export default deleteView;
